import { Box, Divider, Typography, alpha, useTheme } from "@mui/material";
import {
  ContactPhone as ContactPhoneIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
  Home as HomeIcon,
  Map as MapIcon,
  Apartment as ApartmentIcon,
  Notes as NotesIcon,
} from "@mui/icons-material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { handleFormatCep } from "src/shared/Utils/FormatCEP";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import { ModernCard } from "./shared/ModernCard";
import { ModernInfoItem } from "./shared/ModernInfoItem";
import { ModernGridInfo } from "./shared/ModernGridInfo";

export const CardDadosContatoModern = () => {
  const { valueContractInternal } = useContextContrato();

  if (!valueContractInternal) return null;

  const {
    email,
    telefone_1,
    telefone_2,
    cep,
    endereco,
    endereco_numero,
    bairro,
    uf,
    cidade,
    complemento,
    observacoes,
  } = valueContractInternal;

  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <ModernCard title="Informações de Contato" icon={<ContactPhoneIcon />}>
      {/* Contatos */}
      <ModernGridInfo columns={2}>
        <ModernInfoItem
          icon={<EmailIcon />}
          label="Email"
          value={email}
          fullWidth
        />
        <ModernInfoItem
          icon={<PhoneIcon />}
          label="Telefone 1"
          value={cpfOurCnpj({
            text: telefone_1,
            type: "phone",
          })}
        />
        <ModernInfoItem
          icon={<PhoneIcon />}
          label="Telefone 2"
          value={cpfOurCnpj({
            text: telefone_2,
            type: "phone",
          })}
        />
      </ModernGridInfo>

      {/* Separador com ícone de endereço */}
      <Box sx={{ my: 3 }}>
        <Divider>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.5,
              borderRadius: "20px",
              bgcolor: alpha(primaryColor, 0.08),
            }}
          >
            <LocationIcon sx={{ fontSize: 18, color: primaryColor }} />
            <Typography
              variant="caption"
              sx={{ color: primaryColor, fontWeight: 600, letterSpacing: 0.5 }}
            >
              ENDEREÇO
            </Typography>
          </Box>
        </Divider>
      </Box>

      {/* Endereço */}
      <ModernGridInfo columns={2}>
        <ModernInfoItem
          icon={<MapIcon />}
          label="CEP"
          value={handleFormatCep(cep)}
        />
        <ModernInfoItem
          icon={<HomeIcon />}
          label="Endereço"
          value={endereco}
        />
        <ModernInfoItem
          icon={<HomeIcon />}
          label="Número"
          value={endereco_numero}
        />
        <ModernInfoItem
          icon={<ApartmentIcon />}
          label="Bairro"
          value={bairro}
        />
        <ModernInfoItem
          icon={<LocationIcon />}
          label="Cidade"
          value={cidade}
        />
        <ModernInfoItem
          icon={<MapIcon />}
          label="UF"
          value={uf}
        />
        {complemento && (
          <ModernInfoItem
            icon={<HomeIcon />}
            label="Complemento"
            value={complemento}
            fullWidth
          />
        )}
      </ModernGridInfo>

      {observacoes && (
        <>
          <Box sx={{ my: 3 }}>
            <Divider>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 0.5,
                  borderRadius: "20px",
                  bgcolor: alpha(primaryColor, 0.08),
                }}
              >
                <NotesIcon sx={{ fontSize: 18, color: primaryColor }} />
                <Typography
                  variant="caption"
                  sx={{
                    color: primaryColor,
                    fontWeight: 600,
                    letterSpacing: 0.5,
                  }}
                >
                  OBSERVAÇÃO
                </Typography>
              </Box>
            </Divider>
          </Box>

          <ModernInfoItem
            icon={<NotesIcon />}
            label="Observação"
            value={observacoes}
            fullWidth
          />
        </>
      )}
    </ModernCard>
  );
};
